import { render } from "./services-type-form-page.vue?vue&type=template&id=697eeb2a"
import script from "./services-type-form-page.vue?vue&type=script&lang=js"
export * from "./services-type-form-page.vue?vue&type=script&lang=js"

import "./services-type-form-page.vue?vue&type=style&index=0&id=697eeb2a&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__